class CollectionFilterSearch {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="collection-filter"]',
			input: '[data-collection-search]',
			item: '[data-collection-item]',
			letterGroup: '[data-collection-letter]',
			empty: '[data-collection-empty]',
		}, config);

		this.init();
	}

	init() {
		$(document)
			.off('input.collectionSearch', this.config.input)
			.on('input.collectionSearch', this.config.input, (event) => this.handleSearch(event));
	}

	handleSearch(event) {
		let $input = $(event.currentTarget);
		let $scope = $input.closest(this.config.scope);
		let query = this.normalize($input.val());

		let visibleCount = 0;

		$scope.find(this.config.item).each((index, element) => {
			let $item = $(element);
			let match = this.normalize($item.data('title')).indexOf(query) !== -1;
			$item.toggleClass('d-none', !match);
			if (match) {
				visibleCount++;
			}
		});

		$scope.find(this.config.letterGroup).each((index, element) => {
			let $group = $(element);
			let hasVisible = $group.find(this.config.item).not('.d-none').length > 0;
			$group.toggleClass('d-none', !hasVisible);
		});

		$scope.find(this.config.empty).toggleClass('d-none', visibleCount > 0);
	}

	normalize(value) {
		return (value ?? '')
			.toString()
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.trim();
	}
}

export default new CollectionFilterSearch;